import { render, staticRenderFns } from "./UserGroupTableActions.vue?vue&type=template&id=38248eb7"
import script from "./UserGroupTableActions.vue?vue&type=script&lang=js"
export * from "./UserGroupTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports